import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "88",
  height: "48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "var(--td-component-border)",
  d: "M0 0h88v48H0z"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M44 20.583a3.417 3.417 0 1 0 0 6.833 3.417 3.417 0 0 0 0-6.833ZM39.083 24a4.917 4.917 0 1 1 9.834 0 4.917 4.917 0 0 1-9.834 0ZM43.25 17.333v-2.5h1.5v2.5h-1.5ZM48.184 18.755l1.767-1.767 1.06 1.06-1.767 1.768-1.06-1.06ZM50.667 23.25h2.5v1.5h-2.5v-1.5ZM49.244 28.183l1.768 1.768-1.06 1.06-1.768-1.767 1.06-1.06ZM44.75 30.666v2.5h-1.5v-2.5h1.5ZM39.816 29.244l-1.767 1.768-1.061-1.061 1.767-1.768 1.061 1.061ZM37.333 24.75h-2.5v-1.5h2.5v1.5ZM38.755 19.816l-1.767-1.768 1.06-1.06 1.768 1.767-1.06 1.06Z",
  fill: "var(--td-text-color-primary)"
}, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }